"use strict";

exports.__esModule = true;
exports.default = void 0;

var _fontSizeBase = _interopRequireDefault(require("../themes/fontSizeBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper to convert a px value to ems, relative to the base font size
 */
var REGEX_NUM_OR_END_IN_PX = /^[\d.]+(px)?$/;

var convert = function convert(input) {
  return input / parseInt(_fontSizeBase.default) + "em";
};

var errorMsg = function errorMsg(actual) {
  var value = typeof actual === 'string' ? actual : typeof actual;
  return "[mineral-ui/styles/pxToEm]: Expected a number or string in px units. Instead got: '" + value + "'.";
};

var pxToEm = function pxToEm(value) {
  if (typeof value === 'number') {
    return convert(value);
  }

  if (typeof value === 'string' && REGEX_NUM_OR_END_IN_PX.test(value)) {
    return convert(parseFloat(value));
  }

  throw new Error(errorMsg(value));
};

var _default = pxToEm;
exports.default = _default;